import React from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Vehicle } from '../types';
import { useSelection } from '../context/SelectionContext';

interface VehicleListProps {
  vehicles: Vehicle[];
}

interface VehicleItemProps {
  vehicle: Vehicle;
  quantity: number;
  onQuantityChange: (quantity: number) => void;
}

const VehicleItem: React.FC<VehicleItemProps> = ({ vehicle, quantity, onQuantityChange }) => {
  const total = vehicle.price * quantity;

  const handleDecrease = () => {
    if (quantity > 0) {
      onQuantityChange(quantity - 1);
    }
  };

  const handleIncrease = () => {
    onQuantityChange(quantity + 1);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Math.max(0, parseInt(e.target.value) || 0);
    onQuantityChange(value);
  };

  return (
    <Row className="py-3 align-items-center border-bottom vehicle-item" data-vehicle={vehicle.id}>
      <Col md={4}>
        {vehicle.name}
      </Col>
      <Col md={3}>
        <div className="d-flex justify-content-center">
          <div className="input-group" style={{ maxWidth: '120px' }}>
            <Button
              variant="outline-secondary"
              className="decrease-quantity"
              onClick={handleDecrease}
            >
              -
            </Button>
            <Form.Control
              type="number"
              className="text-center quantity-input"
              value={quantity}
              min="0"
              onChange={handleInputChange}
            />
            <Button
              variant="outline-secondary"
              className="increase-quantity"
              onClick={handleIncrease}
            >
              +
            </Button>
          </div>
        </div>
      </Col>
      <Col md={2} className="text-center price-per-piece">
        €{vehicle.price.toFixed(2)}/piece
      </Col>
      <Col md={3} className="text-end total-price fw-bold">
        €{total.toFixed(2)}
      </Col>
    </Row>
  );
};

const VehicleList: React.FC<VehicleListProps> = ({ vehicles }) => {
  const { selectedItems, addToSelection, updateSelection } = useSelection();

  const getQuantityForVehicle = (vehicleId: string): number => {
    const selectedItem = selectedItems.find(item => item.vehicle.id === vehicleId);
    return selectedItem ? selectedItem.quantity : 0;
  };

  const handleQuantityChange = (vehicle: Vehicle, quantity: number) => {
    if (quantity === 0) {
      updateSelection(vehicle.id, 0);
    } else {
      addToSelection(vehicle, quantity);
    }
  };

  return (
    <div className="vehicle-list-container">
      <Row className="py-2 fw-bold border-bottom vehicle-list-header">
        <Col md={4}>Vehicle Model</Col>
        <Col md={3} className="text-center">Quantity</Col>
        <Col md={2} className="text-center">Price/piece</Col>
        <Col md={3} className="text-end">Total</Col>
      </Row>
      <div className="vehicle-list-items">
        {vehicles.map((vehicle) => (
          <VehicleItem
            key={vehicle.id}
            vehicle={vehicle}
            quantity={getQuantityForVehicle(vehicle.id)}
            onQuantityChange={(quantity) => handleQuantityChange(vehicle, quantity)}
          />
        ))}
      </div>
    </div>
  );
};

export default VehicleList;